export class TOC {
    static parse(headingSet) {
        const tocData = [];
        headingSet.forEach((heading, index) => {
            const titleText = heading.innerText;
            const id = heading.id
                ? heading.id
                : `toc-${titleText.replace(/ /g, '-').toLowerCase()}-${index}`;
            const currentTocItem = { id: id, text: titleText };
            if (heading.id === '') {
                heading.id = id;
            }
            tocData.push(currentTocItem);
        });
        return tocData;
    }
    static build(tocData) {
        let result = '<ul class="spv-listGroup spv-listGroup--flush spv-listGroup--withicon">';
        tocData.forEach(toc => {
            result += `<li class="spv-listGroup__item"><a href=#${toc.id}><span class="spv-listGroup__icon"></span>${toc.text}</a></li>`;
        });
        return result + '</ul>';
    }
}
//# sourceMappingURL=table-of-contents.js.map